import clsx from 'clsx';
import styles from './DataList.module.css';
import { LFC } from '../../types';

interface DataListProps {
  className?: string;
}

export const DataList: LFC<DataListProps> = ({ className, children }) => {
  return <dl className={clsx(styles.list, className)}>{children}</dl>;
};
